import { render, staticRenderFns } from "./PlacementActivityTable.vue?vue&type=template&id=c237a1aa&"
import script from "./PlacementActivityTable.vue?vue&type=script&lang=js&"
export * from "./PlacementActivityTable.vue?vue&type=script&lang=js&"
import style0 from "./PlacementActivityTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports